module.exports = __webpack_public_path__ + "static/media/adam.4a58b306.png";